/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import PushService from 'cio/services/push';
import { PlatformDetail } from 'cio/pods/setup-guide/channels/push/controller';
import { PushProvider, Platform } from 'cio/utils/push/platforms';
import { MessagingChannelPushCompletionReason } from 'cio/utils/setup-guide/messaging-channels';
import PushProviderConfigApns from 'cio/components/push-provider-config/apns';
import PushProviderConfigFcm from 'cio/components/push-provider-config/fcm';

interface SetupGuideChannelsPushSetupPlatformArgs {
  isConfiguring: boolean;
  toggleConfiguring: () => unknown;
  complete: (platform: Platform, reason?: MessagingChannelPushCompletionReason) => unknown;
  skip: () => unknown;
  platform: PlatformDetail;
}

export default class SetupGuideChannelsPushSetupPlatform extends Component<SetupGuideChannelsPushSetupPlatformArgs> {
  @service push!: PushService;

  @tracked provider!: PushProvider | null;

  constructor(owner: unknown, args: SetupGuideChannelsPushSetupPlatformArgs) {
    super(owner, args);
    this.setProviderValue();
  }

  @action
  setProviderValue() {
    let platform = this.push.platforms.findBy('key', this.args.platform.id);
    if (platform != null) {
      this.provider = platform.provider;
    } else {
      this.provider = this.args.platform.id === 'android' ? 'fcm' : null;
    }
  }

  get component() {
    if (this.provider === 'apns') {
      return PushProviderConfigApns;
    } else if (this.provider === 'fcm') {
      return PushProviderConfigFcm;
    } else {
      return null;
    }
  }

  @action
  markComplete() {
    this.args.complete(this.args.platform.id);

    // If iOS just got completed with FCM, that means Android is also set up. We can mark
    // that platform as completed too with the correct reason.
    if (this.args.platform.id === 'ios' && this.provider === 'fcm') {
      this.args.complete('android', MessagingChannelPushCompletionReason.IosFcmSetup);
    }

    this.args.toggleConfiguring();
  }
}
